import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  GET_SPECIFIC_HEADER,
} from "pages/standards/QualityManual/utils/urlHelper";
import { ApiServices } from "services/apiServices";
import { buildUrl } from "services/utils";

// Async thunk: Fetch Header
export const fetchHeaderData = createAsyncThunk(
  "layout/fetchHeaderData",
  async (_, { rejectWithValue }) => {
    try {
      let uri = buildUrl(GET_SPECIFIC_HEADER, { type: "header" });
      const result = await ApiServices.callServiceGet(uri);
      if (result?.meta?.success) {
        return result?.data;
      } else {
        return rejectWithValue(result?.meta?.message || "Failed to fetch header");
      }
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error");
    }
  }
);

// // Async thunk: Fetch Footer
// export const fetchFooterData = createAsyncThunk(
//   "layout/fetchFooterData",
//   async (_, { rejectWithValue }) => {
//     try {
//       let uri = buildUrl(GET_SPECIFIC_HEADER, { type: "footer" });
//       const result = await ApiServices.callServiceGet(uri);
//       if (result?.meta?.success) {
//         return result?.data;
//       } else {
//         return rejectWithValue(result?.meta?.message || "Failed to fetch footer");
//       }
//     } catch (error) {
//       return rejectWithValue(error.message || "Unexpected error");
//     }
//   }
// );

// Initial State
const initialState = {
  header: {
    data: {},
    status: "idle",
    error: null,
  },
  // footer: {
  //   data: {},
  //   status: "idle",
  //   error: null,
  // },
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    clearHeader: (state) => {
      state.header = { data: {}, status: "idle", error: null };
    },
    // clearFooter: (state) => {
    //   state.footer = { data: {}, status: "idle", error: null };
    // },
  },
  extraReducers: (builder) => {
    // Header
    builder
      .addCase(fetchHeaderData.pending, (state) => {
        state.header.status = "loading";
        state.header.error = null;
      })
      .addCase(fetchHeaderData.fulfilled, (state, action) => {
        state.header.status = "succeeded";
        state.header.data = action.payload;
      })
      .addCase(fetchHeaderData.rejected, (state, action) => {
        state.header.status = "failed";
        state.header.error = action.payload;
      });

    // // Footer
    // builder
    //   .addCase(fetchFooterData.pending, (state) => {
    //     state.footer.status = "loading";
    //     state.footer.error = null;
    //   })
    //   .addCase(fetchFooterData.fulfilled, (state, action) => {
    //     state.footer.status = "succeeded";
    //     state.footer.data = action.payload;
    //   })
    //   .addCase(fetchFooterData.rejected, (state, action) => {
    //     state.footer.status = "failed";
    //     state.footer.error = action.payload;
    //   });
  },
});

export const { clearHeader, clearFooter } = layoutSlice.actions;
export default layoutSlice.reducer;

// Selectors
export const selectHeaderState = (state) => state.layout.header;
export const selectFooterState = (state) => state.layout.footer;
